/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './mapScraper.css';

function MapScraper() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSe0MMn7DxkAt4cGoPwgcES9VSGSElcUuxz3VQJyys5mDt_6Iw/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">Email Maps Scraper</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product created for email marketers who want to enhance their websites with smart, automated features.
            </p>

            <p>
              After submitting the form, this assistant will scrape the selected input field and send back a list of emails found — directly to your inbox.
              <strong> Please enter the email address where you’d like to receive the results.</strong>
            </p>

            <p>
              <i>
                *Each agents logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, youre instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to request history.
              </i>
            </p>

            <p>
              <strong>NOTE: </strong>
              If youd like to learn more on how to offer this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer"> Calendly.</a>
              <div>
                <br />
                {/* <a href="https://www.loom.com/share/YOUR-VIDEO-ID-HERE" target="_blank" rel="noopener noreferrer">Watch the quick explainer video.</a> */}
              </div>
            </p>
          </div>
          <div className="required-note">
            <span className="required-symbol">*</span>
            indicates required field
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>
            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.335192588"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* City */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="city" // icp
                  name="entry.1582691771"
                  required
                  className="form-input"
                  placeholder="Barcelona"
                />
                <label htmlFor="icp" className="select-label required">
                  City
                </label>
              </div>
            </div>

            {/* Industry Pain Point Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="service" // painPoint
                  name="entry.384639143"
                  required
                  className="form-input"
                  placeholder="Restaurants"
                />
                <label htmlFor="painPoint" className="select-label required">
                  Service
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MapScraper;
